export const calcResizedUrl = (imagesEndpoint: string, uuid: string, paramString: string) => {
  return `${imagesEndpoint}/images/${calcResizedPath(uuid, paramString)}`;
};

const calcResizedPath = (uuid: string, paramString: string) => {
  return `resized/${paramString}/${uuid}.jpg`;
};
